import AbstractProvidedClass from "../shared/AbstractProvidedClass";
import EventTypes from "../shared/EventTypes";

export default class AbstractSideBar extends AbstractProvidedClass {
    tabContainer;
    tabs;
    menuStart = 0;
    config = {
        'search': { icon: 'add-circle-line', tooltip: 'Add a plant (S)' },
        'lists': { icon: 'list-unordered', tooltip: 'Lists (L)' },
        'info': { icon: 'information-line', tooltip: 'Info (I)' },
        'elements': { icon: 'shape-line', tooltip: 'Elements (T)' },
        'plants': { icon: 'plant-line', tooltip: 'Plants (P)' },
    };

    init() {
        this.menuWidth = 40;
        this.menuContainer = this.p.createDiv('')
            .parent('#p5canvas')
            .id('sidebar-menu')
            .style('position', 'fixed')
            .style('top', '0px')
            .style('right', '0px')
            .style('width', `${this.menuWidth}px`)
            .style('height', '100dvh')
            .style('background-color', '#fff')
            .style('border-left', '2px solid #000')
            .style('display', 'flex')
            .style('flex-direction', 'column');

        this.createButtons();

        this.width = 300;

        this.tabContainer = this.p.createDiv().parent('#p5canvas')
            .id('sidebar')
            .style('position', 'fixed')
            .style('right', `${this.menuWidth}px`)
            .style('top', '0px')
            .style('width', `${this.width}px`)
            .style('height', '100dvh')
            .style('background-color', '#fff')
            .style('border-left', '2px solid #000')
            .style('overflow-y', 'auto')
            .style('z-index', 8);

        if (this.mobile) {
            this.isOpen = false;
            this.tabContainer.hide();
            this.closeButton.hide();
            this.openButton.show();
        } else {
            this.isOpen = true;
        }

        // this.on(EventTypes.RESIZE_WINDOW, () => this.resizeWindow());
    }

    resizeWindow() {
        // this.x = this.x = this.p.width - (this.isOpen ? this.width : 0);
        // this.tabContainer.position(this.x - this.labelWidth, 0);
        // Object.values(this.tabs).map((tab) => tab.resizeWindow());
    }

    createButtons() {
        this.createOpenCloseButton();
        this.buttons = {};
        this.options.map( name => {
            this.buttons[name] = this.createButton(name, this.config[name].icon, this.config[name].tooltip);
        });
    }

    createOpenCloseButton() {
        this.openCloseButtonContainer = this.p.createDiv()
                .parent(this.menuContainer)
                .size(this.menuWidth, this.menuWidth)
                .style('display: flex')
                .style('flex-direction: column')
                .style('align-items: center')
                .style('justify-content: center')
                .style('background: #B8E9E4')
                .style('border-bottom: 2px solid #000');

        this.closeButton = this.p.createButton('<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#arrow-right-line"></use></svg>')
            .parent(this.openCloseButtonContainer)
            .class('planner-tab -u-tt-bottom')
            .attribute('data-tooltip', 'Close sidebar')
            .size(this.menuWidth, this.menuWidth)
            .mousePressed(() => this.emit(EventTypes.CLOSE_SIDEBAR));

        this.openButton = this.p.createButton('<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#arrow-left-line"></use></svg>')
            .parent(this.openCloseButtonContainer)
            .class('planner-tab -u-tt-bottom')
            .attribute('data-tooltip', 'Open sidebar')
            .size(this.menuWidth, this.menuWidth)
            .mousePressed(() => this.emit(EventTypes.OPEN_SIDEBAR));

        this.openButton.hide();

        this.on(EventTypes.OPEN_SIDEBAR, () => {
            this.open();
            this.closeButton.show();
            this.openButton.hide();
        });
        this.on(EventTypes.CLOSE_SIDEBAR, () => {
            this.close();
            this.closeButton.hide();
            this.openButton.show();
        });
    }

    createButton(name, icon, tooltip) {
        let wrapper = this.p.createDiv('')
            .parent(this.menuContainer)
            .size(this.menuWidth, this.menuWidth)
            .style('display', 'flex')
            .style('flex-direction', 'column')
            .style('align-items', 'center')
            .style('justify-content', 'center');

        let btn = this.p.createDiv()
            .parent(wrapper)
            .html(`<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#${icon}"></use></svg>`)
            .size(this.menuWidth, this.menuWidth-2)
            .style('border', 'none')
            .style('background', 'transparent')
            .class('planner-tab')
            .attribute('data-tooltip', tooltip)
            .mousePressed(() => this.sideBar.setTab(name));

        let separator = this.p.createDiv('')
            .parent(wrapper)
            .size(this.menuWidth * 0.7, 1)
            .style('background', '#333');

        return btn;
    }

    hovered() {
        return this.p.mouseX > (
            this.p.windowWidth - (
                this.menuWidth + (this.isOpen ? this.width : 0)
            )
        );
    }

    setTab(tab) {
        if (this.openTab) {
            let openTab = this.openTab.name;
            this.buttons[openTab].removeClass('-is-active');
            this.openTab.deactivate();
        }

        this.openTab = this.tabs[tab];
        this.openTab.activate();
        this.buttons[tab].addClass('-is-active')
        this.emit(EventTypes.OPEN_SIDEBAR);
    }

    open() {
        this.isOpen = true;
        this.tabContainer.show();
        // this.resizeWindow();
        this.openTab.activate();
    }

    close() {
        this.isOpen = false;
        this.tabContainer.hide();
        // this.resizeWindow();
        this.openTab.deactivate();
    }
}
